// extracted by mini-css-extract-plugin
module.exports = {"root":"PricingBlock_root__MpRya","title":"PricingBlock_title__GOtN0"};